module.exports = __webpack_public_path__ + "static/img/8-2.add10c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/sky102/8-2.png
// module id = 2xWn
// module chunks = 1